import type { z } from 'zod';
import type { InfiniteData } from '@tanstack/react-query';

import type { fileSchema, locationSchema } from '~/constants';
import type { ILocationRequest, TListResponse } from '~/types';

export function sanitizeSignedIds(
  files: Array<z.infer<typeof fileSchema>>,
): string[] {
  return (files || []).map((f) => f?.signedId || '');
}

export function sanitizeLocations(
  locations: z.infer<typeof locationSchema>[],
): ILocationRequest[] {
  return locations.map(
    ({ city, country, latitude, longitude, state, address, id, name }) => {
      return {
        id,
        name,
        city,
        state,
        address,
        country,
        latitude,
        longitude,
      };
    },
  );
}

export function sanitizeInfiniteData<T>(
  data: InfiniteData<TListResponse<T>, unknown>,
): T[] {
  return data.pages.reduce<T[]>((result, page) => {
    result = result.concat(page[0] || []);

    return result;
  }, []);
}
